import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import { TemplateType, getTemplateById } from './types';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(3),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  title: {
    fontWeight: 600,
    color: '#333',
    fontSize: '18px',
  },
  description: {
    color: '#6b7280',
    marginBottom: theme.spacing(1.5),
    fontSize: '0.875rem',
  },
  configButton: {
    textTransform: 'none',
  },
  selectedInfo: {
    marginTop: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#059669',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface TemplateConfiguratorProps {
  selectedTemplate?: TemplateType | null;
  onOpenModal?: () => void;
  disabled?: boolean;
}

const TemplateConfigurator: React.FC<TemplateConfiguratorProps> = ({
  selectedTemplate,
  onOpenModal,
  disabled = false,
}) => {
  const classes = useStyles();

  // Get template display name
  const templateName = selectedTemplate ? getTemplateById(selectedTemplate)?.name || selectedTemplate : null;

  return (
    <div className={classes.container}>
      <Typography variant="h5" className={classes.title}>
        Template & Styling
      </Typography>
      <Typography variant="body2" className={classes.description}>
        Choose how your internal links will be displayed on your pages.
      </Typography>
      <Button
        variant="outlined"
        startIcon={<SettingsIcon />}
        onClick={onOpenModal}
        disabled={disabled}
        style={{
          textTransform: 'none',
          // Inline colors override MUI's disabled styling, so set the disabled colors explicitly
          borderColor: disabled ? 'rgba(0, 0, 0, 0.12)' : '#d1d5db',
          color: disabled ? 'rgba(0, 0, 0, 0.26)' : '#374151',
          backgroundColor: '#fff',
          padding: '8px 16px',
        }}
      >
        {selectedTemplate ? 'Edit Template' : 'Configure Template'}
      </Button>

      {selectedTemplate && templateName && (
        <div className={classes.selectedInfo}>
          <span>✓</span>
          <span>Selected: {templateName}</span>
        </div>
      )}
    </div>
  );
};

export default TemplateConfigurator;
